'use client'
export const GoogleOAuthLoginButton: React.FC = () => (
  <div>
    <a href="/api/users/oauth2/google?state=app=admin">
      <button
        className="btn btn--icon-style-without-border btn--size-large btn--withoutPopup btn--style-primary btn--withoutPopup"
        style={{ width: '100%' }}
      >
        Continue With Google
      </button>
    </a>
    {/* <a href="/api/users/oauth2/google?state=app=fe">
      <button
        className="btn btn--icon-style-without-border btn--size-large btn--withoutPopup btn--style-primary btn--withoutPopup"
        style={{ width: '100%' }}
      >
        Continue With Google (redirect to FE)
      </button>
    </a> */}
  </div>
)
